import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import SidebarLayout from '../components/Sidebar'
import { Box, Chip, Divider, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

const categories = [
  { catId: 1, catName: "Music Tones", rbtCodesOfCategoryCount: 15 },
  { catId: 2, catName: "Funny Tones", rbtCodesOfCategoryCount: 8 },
  { catId: 3, catName: "Love Tones", rbtCodesOfCategoryCount: 12 },
  { catId: 4, catName: "Bollywood Hits", rbtCodesOfCategoryCount: 20 },
  { catId: 5, catName: "Instrumental", rbtCodesOfCategoryCount: 6 },
  { catId: 6, catName: "Classical", rbtCodesOfCategoryCount: 10 },
  { catId: 7, catName: "Regional Songs", rbtCodesOfCategoryCount: 14 },
  { catId: 8, catName: "Devotional", rbtCodesOfCategoryCount: 9 },
  { catId: 9, catName: "Pop & Rock", rbtCodesOfCategoryCount: 18 },
  { catId: 10, catName: "Special Occasions", rbtCodesOfCategoryCount: 5 },
];

const Store = () => {

  const [rbtCategories, setRbtCategories] = useState<any[]>([])
  const navigate = useNavigate();
  const { countryCode, msisdn } = useSelector(
            (state: RootState) => state.phone
          );

  const getAllCategories = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/Content/ShowCategories?msisdn=${countryCode+msisdn}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}`);
    setRbtCategories(res?.data?.catList);
  }

  useEffect(() => {
    getAllCategories();
  },[])

  return (
    <Layout>
        <SidebarLayout>

        <Box
      sx={{
        // maxWidth: 700,
        mx: "auto",
        p: 3,
        backgroundColor: "#fff",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontFamily: "sans-serif",
          color: "#0085ca",
          mb: 2,
        }}
      >
        Store
      </Typography>

      <List
        sx={{
          border: "1px solid #ddd",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        {rbtCategories?.map((item, index) => (
          <React.Fragment key={item.catId}>
            <ListItemButton
            onClick={() => navigate(`/flowtone/storeDetail?catId=${item.catId}`, {state: item})}
              // component="a"
              // href={`/flowtone/storeDetail?catId=${item.catId}`}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py: .5,
                color: "#0085ca",
                fontFamily: "sans-serif",
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#f4f9ff",
                },
              }}
            >
              <ListItemText sx={{textTransform: "uppercase", fontSize: "16px"}} primary={item.catName} />
              <Chip
                label={item.rbtCodesOfCategoryCount}
                color="primary"
                size="small"
                sx={{
                  fontWeight: "bold",
                  backgroundColor: "#0085ca",
                  color: "#fff",
                }}
              />
            </ListItemButton>
            {index < categories.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
        </SidebarLayout>
        </Layout>
  )
}

export default Store